import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/Wreadia-logo.svg")